import { render } from "./Item7.vue?vue&type=template&id=e2a0441c"
import script from "./Item7.vue?vue&type=script&lang=ts"
export * from "./Item7.vue?vue&type=script&lang=ts"
script.render = render

export default script